import React, { useMemo, FC } from 'react';

import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';

import createLaunchDarklyContext, {
  LaunchDarklyContextValue,
  LaunchDarklyProviderProps,
} from './LaunchDarklyContext';

const LD_API_KEYS = {
  [ENVS.QA]: '5e4c38359d07d807cfb6fc26',
  [ENVS.STAGING]: '5e4c3835aadaaf0815842d0e',
  [ENVS.PRODUCTION]: '5e4c3834d497f707dd287f20',
};

export const AlloyLaunchDarklyContext = getOrCreateGlobalContext<
  LaunchDarklyContextValue | undefined
>(CONTEXT_NAMES.AlloyLaunchDarklyContext);

const {
  LaunchDarklyProvider,
  useFeatureFlag: useAlloyFeatureFlag,
  useAllFeatureFlags: useAlloyAllFeatureFlags,
} = createLaunchDarklyContext(AlloyLaunchDarklyContext);

type AlloyLaunchDarklyProviderProps = Omit<
  LaunchDarklyProviderProps,
  'apiKey'
> & {
  // Make apiKey optional
  apiKey?: LaunchDarklyProviderProps['apiKey'];
};

const AlloyLaunchDarklyProvider: FC<AlloyLaunchDarklyProviderProps> = (
  props
) => {
  const env = getEnv();
  const apiKey = useMemo(() => LD_API_KEYS[env], [env]);
  return <LaunchDarklyProvider apiKey={apiKey} {...props} />;
};

export {
  useAlloyFeatureFlag,
  useAlloyAllFeatureFlags,
  AlloyLaunchDarklyProvider,
};
